import { makeStubAdapter } from './_stub';
export const youtubeAdapter = makeStubAdapter('youtube');
